import React from "react";
import { useTranslation } from "react-i18next";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

/**
 * @Description this page Number Library's Sum Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Sum({
  action,
  variables,
  setOpenVariable,
  variableRender,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.NUMBER.";

  return (
    <div>
      <div className="form-element">
        {t(label + "ENTER-A-NUMBER")}
        <TextInput
          action={action}
          inputName="number"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
        />
      </div>
      <div className="form-element">
        {t(label + "ENTER-A-INCREMENT")}
        <TextInput
          action={action}
          inputName="incrementValue"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
        />
        <small>{"{e.q. 1"}</small>
      </div>
      <div className="form-element">
        {t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")}
        <VariablePicker
          action={action}
          inputName="set"
          variables={variables}
          setOpenVariable={setOpenVariable}
          variableRender={variableRender}
          isRequired={true}
        />
      </div>
    </div>
  );
}
